import React, { FC, SyntheticEvent } from "react";
import Modal from "react-modal";
import cn from "clsx";
import { useIsRTL } from "@/hooks";

const ModalBfl: FC<{
  showModal: boolean;
  closeModal?: (e: SyntheticEvent) => void;
  modalClass?: string;
  overlayClassName?: string;
  modalCustomStyle?: any;
  children?: any;
  zIndex?: number;
  closeTimeoutMS?: number;
}> = ({
  showModal,
  closeModal,
  modalClass,
  overlayClassName,
  modalCustomStyle,
  children,
  zIndex,
  closeTimeoutMS = 200
}) => {
  const isRTL = useIsRTL();

  const customStyles = {
    overlay: {
      zIndex: zIndex || "15"
    }
  };

  return (
    <div className="modal_wrapper">
      <Modal
        isOpen={showModal}
        onRequestClose={closeModal}
        className={cn("Modal", modalClass, { arabic: isRTL })}
        overlayClassName={cn("overlay", overlayClassName)}
        contentLabel="Example Modal"
        style={{ ...customStyles, ...modalCustomStyle }}
        closeTimeoutMS={closeTimeoutMS}
        shouldCloseOnOverlayClick={true}
      >
        {children}
      </Modal>
    </div>
  );
};

Modal.setAppElement("#root");

export default ModalBfl;
